<template>
  <v-card flat>
    <v-card-title>
      <span class="headline">{{editMode ? 'Edit': 'Add'}} client</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row :style="editMode ? 'max-width:500px' : 'width:100%'">
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              outlined
              dense
              v-model="client.name"
              :error-messages="nameErrors"
              label="Name"
              required
              hint="Alice Smith"
              @input="$v.client.name.$touch()"
              @blur="$v.client.name.$touch()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <vue-tel-input
              ref="phone"
              :style="{borderColor: this.isValid ? 'yellowgreen' : '' }"
              v-model="client.phoneNumber"
              @onInput="onInput"
              @onBlur="$v.client.phoneNumber.$touch()"
              placeholder="Phone number"
              required
            ></vue-tel-input>
          </v-col>
          <!-- <v-col cols="1" sm="1" md="1">
            <template v-if="this.isValid">
              <v-icon color="green">mdi-check</v-icon>
            </template>
          </v-col>-->
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              outlined
              v-model="client.description"
              @input="$v.client.description.$touch()"
              label="Description"
            ></v-text-field>
            <v-switch
              v-model="client.sendSMS"
              @change="$v.client.sendSMS.$touch()"
              label="Send SMS to this client?"
            ></v-switch>

            <!-- <v-col cols="12">
              <v-text-field
                v-model="email"
                :error-messages="emailErrors"
                label="E-mail"
                required
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
              ></v-text-field>
            </v-col>-->

            <v-radio-group label="Language:" v-model="client.languageId" :mandatory="true">
              <v-radio
                v-for="language in languages"
                :key="language.id"
                
                :label="language.name"
                :value="language.id"
                @change="$v.client.languageId.$touch()"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn v-if="!editMode" light color="primary" @click="closeDialog()">Close</v-btn>
      <v-spacer v-if="!editMode"></v-spacer>
      <v-btn v-if="showSaveButton" light color="primary" @click="saveClient">
        <v-icon dark>mdi-content-save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import { VueTelInput } from "vue-tel-input";
import axios from "axios";
export default {
  components: {
    VueTelInput
  },
  props: ["client"],
  data: () => ({
    isVisible: false,
    isValid: false,

    languages: []
  }),
  validations: {
    client: {
      name: {
        required,
        minLength: minLength(2)
      },
      phoneNumber: {
        required
      },
      sendSMS: {
        required
      },
      languageId: {
        required
      },
      description: {}
      //   email: {
      //     email
      //   }
    }
  },
  computed: {
    showSaveButton() {
      if (!this.editMode) {
        return (
          this.$v.client.$anyDirty &&
          this.$v.client.$invalid == false &&
          this.isValid
        );
      } else {
        return this.$v.client.$anyDirty && this.$v.client.$invalid == false;
      }
    },
    editMode() {
      return this.client.id != null;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.client.name.$dirty) return errors;
      !this.$v.client.name.minLength &&
        errors.push("Name must be at least 2 characters long");
      !this.$v.client.name.required && errors.push("Name is required");
      return errors;
    }
    // emailErrors() {
    //   const errors = [];
    //   if (!this.$v.client.email.$dirty) return errors;
    //   !this.$v.client.email.email && errors.push("Must be valid e-mail");
    //   // !this.$v.emailAddress.required && errors.push("E-mail is required");
    //   return errors;
    // }
  },
  mounted() {
    this.getLanguages();
  },
  methods: {
    onInput({ isValid }) {
      this.isValid = isValid;
      if (isValid) {
        this.$v.client.phoneNumber.$touch();
      }
    },
    validate() {},
    getLanguages() {
      var queryString = `query { languages { id, name } }`;
      axios
        .post("/graphql", {
          query: queryString
        })
        .then(res => {
          this.languages = res.data.data.languages.reverse();
          // this.client.languageId = this.client.languageId //this.languages[0].id;
        })
        .catch(() => {
          this.showError("Error occured while getting languages!");
        });
    },

    closeDialog() {
      this.$v.$reset();
      this.isValid = false;
      this.$emit("close");
    },
    saveClient() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var client = {
          client: {
            id: this.client.id ?? null,
            name: this.client.name
              .toLowerCase()
              .split(" ")
              .map(s => s.charAt(0).toUpperCase() + s.substring(1))
              .join(" "),
            phonenumber: this.client.phoneNumber.replace(/\s/g, ""),
            //   emailaddress: this.emailAddress.toLowerCase(),
            description: this.client.description,
            companyId: this.$store.getters.user.details.companyId,
            sendSMS: this.client.sendSMS,
            languageId: this.client.languageId
          }
        };

        let mutation = ` mutation saveclient($client: saveclient!) {
                                saveclient(client: $client) {
                                id
                                }
                            }`;
        axios
          .post("/graphql", {
            query: mutation,
            variables: client
          })
          .then(res => {
            console.log(res);
            //this.$emit("getClients", res.data.data.saveclient.id);
            this.closeDialog();
          })
          .catch(() => {
            this.showError("Could not save client");
          });
      }
    }
  }
};
</script>

<style scoped>
.vue-tel-input {
  min-height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
}
.vue-tel-input:hover {
  /* border-color: rgba(0, 0, 0, 0.87); */
}
.vti__input:active,
.vti__input:focus {
  border: 2px solid #1976d2;
}
</style>